module.exports = __webpack_public_path__ + "static/media/coinStack.daafd14b.svg";